const userIdName = 'sp-corporate-ui.user-id';
const organizationIdName = 'sp-corporate-ui.tennant-id';

export const getOrgId = () => {
  return sessionStorage.getItem(organizationIdName) || '';
};

export const setOrgId = (organizationId: string) => {
  sessionStorage.setItem(organizationIdName, organizationId);
};

export const getUserId = () => {
  return sessionStorage.getItem(userIdName) || '';
};

export const setUserId = (userId: string) => {
  sessionStorage.setItem(userIdName, userId);
};

export const isProd = process.env.REACT_APP_ENV === 'prod';
